import { render, staticRenderFns } from "./EtapaPeriferico.vue?vue&type=template&id=28e55230"
import script from "./EtapaPeriferico.vue?vue&type=script&lang=js"
export * from "./EtapaPeriferico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports